// GA4 に送っているイベントの全量・発火点・既知の誤差・GA4 管理画面側で必要な設定は
// frontend/docs/ANALYTICS.md にまとめてある。イベントを足したらそちらも更新する。
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import ReactGA from 'react-ga4'
import { setNewRelicRouteName } from '../utils/newrelic'

// react-ga4 v3 は UaEventOptions 型を公開しないためローカルに定義（v3 の型定義と一致）
type UaEventOptions = {
  action: string
  category: string
  label?: string
  value?: number
  nonInteraction?: boolean
  transport?: 'beacon' | 'xhr' | 'image'
}

const GA4_ID = import.meta.env.VITE_GA4_ID as string
if (GA4_ID) ReactGA.initialize(GA4_ID)

export const usePageTracking = () => {
  const location = useLocation()
  useEffect(() => {
    if (GA4_ID) ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    })
    setNewRelicRouteName(location.pathname)
  }, [location.pathname, location.search])
}

export const trackEvent = (optionsOrName: UaEventOptions | string, params?: object) => {
  if (GA4_ID) {
    ReactGA.event(optionsOrName, params)
  }
}

export const trackEventPromise = (
  optionsOrName: UaEventOptions | string, params?: object
): Promise<void> =>
  new Promise<void>(resolve=> {
    if (!GA4_ID) resolve()
    else ReactGA.event(optionsOrName, {
      ...params,
      event_callback: resolve,
    })
  })
